import React from "react";
import { createPortal } from "react-dom";

/**
 * Alert modal matching the design: white box, bold heading, body text, single "Okay" button (muted green).
 * Use in place of window.alert().
 */
const AlertModal = ({ open, title, body, onClose }) => {
  if (!open) return null;

  const content = (
    <div
      className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4"
      onClick={(e) => e.target === e.currentTarget && onClose?.()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="alert-modal-title"
    >
      <div
        className="bg-white w-full max-w-md rounded-xl shadow-xl p-6 mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          id="alert-modal-title"
          className="text-lg font-BonaNovabold text-[#101828] text-center leading-snug mb-3"
        >
          {title}
        </h2>
        {body ? (
          <p className="text-sm font-Montserratmedium text-[#101828] text-center leading-relaxed mb-6">
            {body}
          </p>
        ) : null}
        <div className="flex justify-center">
          <button
            type="button"
            onClick={onClose}
            className="bg-[#94b08d] hover:bg-[#849d7e] text-white px-8 py-2.5 rounded-lg text-sm font-Montserratmedium transition-colors"
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
};

export default AlertModal;
